<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.surveys', 2),
                        href: meta.links.survey_index,
                    },
                    {
                        name: $tc('messages.survey_reports', 2),
                        href: meta.links.survey_records_index,
                    },
                    {
                        name: survey.title,
                        href: null,
                    },
                    {
                        name: report.date_display,
                        href: meta.links.show,
                    },
                ]"
            />
        </template>
        <div>
            <SurveyReport :survey="survey" :report="report" />
        </div>
        <div>
            <SurveyAnswerCommentsList :comments="comments" />
            <div class="mt-5">
                <form action="" method="POST" @submit.prevent="submit">
                    <div class="mt-1">
                        <FormLabel :value="$t('messages.comment')" for="comment" />
                        <FormTextarea required id="comment" v-model="form.comment" name="comment" class="mt-2 w-full" />
                        <FormError :value="form.errors.comment" class="mt-2" />
                    </div>
                    <div class="flex justify-end mt-5">
                        <SubmitFormButton :button-text="$t('messages.save')" :processing="form.processing" />
                    </div>
                </form>
            </div>
        </div>

        <div class="mt-5">
            <AppButton element="InertiaLink" :href="meta.links.show">
                {{ survey.title }} - {{ report.date_display }}
            </AppButton>
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import SurveyReport from '../partials/SurveyReport.vue';
import SubmitFormButton from '../../../Activities/Subactivities/SubmitFormButton.vue';
import FormError from '../../../../../components/Forms/FormError.vue';
import FormTextarea from '../../../../../components/Forms/FormTextarea.vue';
import FormLabel from '../../../../../components/Forms/FormLabel.vue';
import SurveyAnswerCommentsList from './SurveyAnswerCommentsList.vue';
import AppButton from '../../../../../components/AppButton.vue';

export default {
    components: {
        AppButton,
        SurveyAnswerCommentsList,
        FormLabel,
        FormTextarea,
        FormError,
        SubmitFormButton,
        SurveyReport,
        PanelPage,
    },
    layout: Layout,
    name: 'Index',
    props: ['meta', 'survey', 'report', 'comments'],
    data() {
        return {
            form: this.$inertia.form({
                comment: null,
            }),
        };
    },
    methods: {
        submit() {
            this.form.post(this.meta.links.store, {
                onSuccess: () => {
                    this.form.reset();
                },
                preserveScroll: true,
            });
        },
    },
};
</script>
